<form class="form-horizontal m-t-20" [formGroup]="formGroup" (ngSubmit)="submit()" *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">MFA Challenge</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="vm.mobile || vm.email; else invalid">
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          As an added security measure, please enter the code we sent to
          {{ sentTo }}.
          <a href="#" (click)="helpCollapse.toggle()">Need help?</a>
        </div>
      </div>
      <div #helpCollapse="ngbCollapse" [ngbCollapse]="true">
        <div class="col-12" *ngIf="vm.mobile">
          If you no longer use the mobile number listed on your profile, speak
          with your supervisor, or phone the help desk.
        </div>
        <div class="col-12" *ngIf="vm.email">
          If you did not receive your code, be sure to check your spam/junk
          folder before contacting your supervisor or calling the help desk.
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1"><i class="ti ti-user"></i></span>
            </div>
            <input type="text" class="form-control" placeholder="Code" formControlName="mfaCode" autofocus />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="invalid-feedback d-block" *ngIf="vm.showFailedAttempt">
        The code was incorrect, please try again.
      </div>
      <button type="submit" [disabled]="formGroup.invalid" class="btn btn-block btn-lg btn-info" ngbAutofocus>
        Submit
      </button>
      <button type="button" class="btn btn-block btn-lg btn-secondary" (click)="resend()">
        Resend Code
      </button>
    </div>
  </ng-container>
  <ng-template #invalid>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 alert alert-danger">
          No valid mobile or email found for MFA. Please contact your supervisor
          or call the help desk.
        </div>
      </div>
    </div>
  </ng-template>
</form>